import { useLayoutEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'qs';
import { useVersionsQuery, VersionsQuery } from 'src/graphql/_generated';

export type VersionObject = NonNullable<VersionsQuery['assessment']>['versions'][number];

interface UseVersionParams {
  assessmentId?: string;
}

interface UseVersionResult {
  versionId: string | undefined;
  version: VersionObject | undefined;
  versions: VersionObject[];
  isLoading: boolean;
  assessmentId: string | undefined;
}

const useVersion = (params: UseVersionParams = {}): UseVersionResult => {
  const { assessmentId: assessmentIdParam } = params;
  const { assessmentId: assessmentIdRoute } = useParams();
  const { search } = useLocation();
  const [versionId, setVersionId] = useState<string | undefined>(undefined);

  const assessmentId = assessmentIdParam || assessmentIdRoute;

  const { data, loading } = useVersionsQuery({
    variables: { assessmentId: assessmentId! },
    skip: !assessmentId,
  });

  const isLoading = loading && !data;

  useLayoutEffect(() => {
    const parsedQuery = qs.parse(search, {
      ignoreQueryPrefix: true,
      strictNullHandling: true,
      plainObjects: true,
      depth: 1,
      decoder: (s) => s,
    });

    if (parsedQuery.version) {
      setVersionId(parsedQuery.version as string);
    } else {
      setVersionId(undefined);
    }
  }, [search]);

  const versions = data?.assessment?.versions || [];
  const version = versionId ? versions.find((v) => v.id === versionId) : undefined;

  return {
    versionId,
    version,
    versions,
    isLoading,
    assessmentId,
  };
};

export default useVersion;
